const selectSlugToEntryIdMap = state => {
  return state.routeTreeManager.slugToEntryIdMap
}

export default {
  selectSlugToEntryIdMap,
}
